import React from "react";
import { AppModel } from "../../models";
import { MainSearchFilter } from "./MainSearchFilter";
import { MainSearchList } from "./MainSearchList";

import "react-reflex/styles.css";
import { DispatchContext } from "../../store";

interface SearchViewProps {
    state: AppModel;
}

export const SearchView = ({ state }: SearchViewProps) => {
    const { dispatch } = React.useContext(DispatchContext);

    return <main className={`st-main ${state.darkTheme ? "dark-theme" : ""}`} style={{
        height: "100%",
        width: "100%"
    }}>
        <div className="st-main__container">
            <div className="st-topbar">
                <a className="st-topbar__logo" href="http://snippet.dhtmlx.com/">
                    <svg viewBox="0 0 40 18" xmlns="http://www.w3.org/2000/svg" className="st-logo-img">
                        <path className="logo line" fill-rule="evenodd" d="M15.5 8.75C15.5 10.4 15.15 11.85 14.45 13.15C13.75 14.45 12.85 15.45 11.75 16.1C10.85 16.7 9.85 17.05 8.8 17.25C7.75 17.4 6.6 17.5 5.4 17.5H0V0H5.4C6.6 0 7.75 0.1 8.85 0.25C9.9 0.4 10.9 0.8 11.85 1.4C13 2.15 13.9 3.15 14.55 4.4C15.15 5.6 15.5 7.1 15.5 8.75ZM23 17.5L27 11.3V6L23 0V6.2H17.5V0H13V1.9C13.8 2.55 14.5 3.35 15 4.35C15.65 5.6 16 7.05 16 8.75C16 10.4 15.65 11.85 14.95 13.15C14.4 14.1 13.75 14.9 13 15.55V17.5H17.5V10.15H23V17.5ZM31.75 11.3L35.05 17.5H40L33.95 8.45L40 0H35.05L31.75 5.1L28.45 0H23.5L29 8.45L23.5 17.5H28.45L31.75 11.3ZM8.80005 3.89999C9.60005 4.34999 10.2 4.99999 10.6 5.79999C11 6.59999 11.2 7.59999 11.25 8.69999C11.25 9.89999 11.05 10.85 10.7 11.65C10.3 12.45 9.75005 13.1 9.05005 13.55C8.45005 13.95 7.80005 14.15 7.15005 14.2C6.45005 14.25 5.65005 14.25 4.65005 14.25H4.55005V3.29999H4.65005C5.55005 3.29999 6.30005 3.29999 6.95005 3.34999C7.60005 3.39999 8.20005 3.54999 8.80005 3.89999Z"/>
                    </svg>
                    <span className="st-logo-text">Code Snippet</span>
                </a>
                <div className="st-topbar__controls">
                    <a id="st_add_live"
                       className="dhx_button dhx_button--color_primary dhx_button--view_flat dhx_button--circle"
                       href="https://snippet.dhtmlx.com/new" target="_blank">
                        <span className="dhx_button__icon dxi dxi-plus"></span>
                        <span className="dhx_button__text">Create live example</span>
                    </a>
                </div>
            </div>
            <div className="st-main-search">
                <MainSearchFilter
                    state={state}
                    dispatch={dispatch}
                />
                <MainSearchList
                    state={state}
                    dispatch={dispatch}
                />
            </div>
        </div>
    </main>;
};
